<div class="wrap">
  <div class="icon">
    <img src="assets/icon/payment-process.svg" alt="payment-icon" />
  </div>
  <div class="text">{{ "@components.paymentProcessing.text" | translate }}</div>
</div>
